import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  add: false, save: false, del: false, rtv: false
};

const pageAuthSlice = createSlice({
  name: 'pageAuth',
  initialState,
  reducers: {
    setPageAuth: (state, action) => {
      return action.payload;
    },
    clearAuth: () => initialState,
  },
});

export const { setPageAuth, clearAuth } = pageAuthSlice.actions;
export default pageAuthSlice.reducer;
